define([
	"dojo/_base/declare",
	"underscore",
	"csi/table/matrix/Path",
], function(declare, _, PathMatrix) {

	return declare(PathMatrix, {
		columnPath: "Child:BOMProductSizes",
		restrictQuery: true,

		/**
		 * @override
		 * Return key indicating size url(s) for column
		 */
		getCompareKeyForMergedCells(ctx, spec, index) {
			const key = spec.key.toString();
			const sizeUrl = spec.columnUrl;
			return `Columns_${key}_${sizeUrl}`;
		},

		/**
		 * @override
		 * Return true if column represents a new size
		 */
		isNewComparisonColumn(ctx, columnUrl) {
			return ctx.view.isNewSize(columnUrl);
		},

		/**
		 * @override
		 * Return true if column represents an old size
		 */
		isOldComparisonColumn(ctx, columnUrl) {
			return ctx.view.isOldSize(columnUrl);
		},

		/**
		 * @override
		 * If matrix is in view, then add necessary dependency paths to PartMaterial query level(s) (could be in multi-level view)
		 */
		onPathSpecParams(ctx, params, columnIndex) {
			const {view} = ctx;
			const ql = view.getMainQueryLevel();
			const paths = [
				"Child:CommonSize;CommonSizeSpec;PartMaterialQuantities",
				"Child:PartMaterialSizes/Child:PMSSize",
				"Child:PartMaterialSizeSpecs/Child:PMSSizeSpec",
			];

			ql.addDependencyPaths(paths);

			if (ql.childLevel) {
				ql.childLevel.addDependencyPaths(paths);
			}
		},

		/**
		 * @override
		 * Replace headings in column matrix with headings in respective solo matrix
		 */
		onPathSubSpecParams(ctx, params, columnIndex) {
			params.heading = ctx.view.getSizeColumnHeading(params.heading);
		},

		/**
		 * @override
		 * Use sizes in active size set to include sizes from comparison view, if one 
		 */
		_getColumnNodes: function(ctx, h) {
			const {bomActiveSizeSet} = ctx.view;
			return bomActiveSizeSet ? bomActiveSizeSet.getAllSizes() : null;
		},

		/**
		  * @override
		  * Find appropriate size variation node based on current column
		  */
		_getSpecNodes(ctx, spec, nodes) {
			const {cache, queryResult, view} = ctx;
			const columnMap = view.getSizeColumnMap(ctx, queryResult, spec.heading.m_id);
			const variation = cache.get(columnMap[spec.columnUrl]);
			return variation ? [variation] : [];
		},

		/**
		 * @override
		 * Add cell edit behavior
		 */
		_renderCellContent(ctx, h, td, columnSpec, index) {
			// size matrices are not editable inline
			ctx.setReadOnly(true);
			this.inherited(arguments);
			ctx.view.postRenderSizeVariationCell(ctx, td, ctx.getNodeType());
		}
	});
});